import { render, staticRenderFns } from "./ClienteFormComponent.vue?vue&type=template&id=751a8716&"
import script from "./ClienteFormComponent.vue?vue&type=script&lang=js&"
export * from "./ClienteFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports